import { render, staticRenderFns } from "./ServiceQuestionEdit.vue?vue&type=template&id=6df72a80"
import script from "./ServiceQuestionEdit.vue?vue&type=script&lang=js"
export * from "./ServiceQuestionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports